  <div class="modal-body text-center m-3">
    <p id="checkin-caps-lock-modal-title-text" class="text-title">Caps Lock is turned on</p>
    <p id="checkin-caps-lock-modal-warning-text" class="text-body">Please turn off Caps Lock to continue scanning.</p>
    <button id="checkin-caps-lock-modal-back-button" type="button" class="btn btn-lg btn-secondary-white mt-1" (click)="back()">Back</button>
  </div>
